import React, { useEffect, useRef, useState } from 'react'
import useFormValidatonCustom, { validationObject } from '../../../../../../hooks/form_validation_hook'
import { useRESTapi } from '../../../../../../hooks/rest_API'
import { Brand, CustomFile, Product, ProductCategory, ProductImage, ProductItem, ProductItemKeys, ProductCategoryKeys, role } from '../../../../../../types'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../../redux/store'
import { IconLoader, IconPlus, IconX } from '@tabler/icons-react'
import { v4 as uuidv4 } from 'uuid';
import { AdminModal, AdminModalContent, AdminModalFooter, AdminModalHeader, AdminModalMiddle, AdminModalTitle } from '@/src/pages/admin/components/modal'
import { Input } from '@/src/components/ui/input'
import { Button } from '@/src/components/ui/button'
import { useAlertModal } from '@/src/hooks/alert_modal'
import { Switch } from '@/src/components/ui/switch'
import { useCheckUserType } from '@/src/hooks/check_user'




type categoryOverview = ProductCategory
type imageIds = string[]



export function AddCategoryModal(
    {
        show,
        closeModal,
        id,
        updateUi,
        mode,
        setShow

    }:
        {
            show: boolean,
            closeModal: () => void,
            id?: string,
            updateUi: () => void,
            mode: 'add' | 'edit',
            setShow: (show: boolean) => any

        }
) {


    const validationObject = {
        [ProductCategoryKeys.M04_ProductCategoryName]: {
            message: '',
            validation: [
                (value) => {

                    if (!value) {
                        return 'required'
                    }
                    return true
                }
            ]
        },
        [ProductCategoryKeys.M04_ProductCategoryImage]: {
            message: '',
            validation: [
                (value) => {
                    if (!value) {
                        return 'required'
                    }
                    return true
                }
            ]
        },
        [ProductCategoryKeys.M04_ProductCategorySlug]: {
            message: '',
            validation: [
                (value: any[]) => {
                    if (!value && mode === 'add') {
                        return 'required'
                    }
                    if (value?.length === 0) {
                        return 'required'
                    }
                    return true
                }
            ]
        },

    } satisfies validationObject

    const api = useRESTapi();
    const [formData, setFormData] = useState<categoryOverview>({
        M04_ProductCategoryImage: '',
        M04_ProductCategoryName: '',
        M04_ParentCategoryId: '',
        M04_ProductCategoryMetaTitle: '',
        M04_ProductCategorySlug: '',
        M04_is_active: 1,
        M04_ProductCategoryMetaDescription: ''
    })
    const employee = useSelector((state: RootState) => state.employee)

    const [isLoading, setIsLoading] = useState(false)
    const { performAllValidation, performValidationOf, errorData, setErrorData } = useFormValidatonCustom<ProductCategory>({
        validationObject: validationObject
    })
    const [loading, set_loading] = useState(false)
    const [add_progress, set_add_progress] = useState(0)
    const alertModal = useAlertModal()

    const [isSpinLoading, setSpinLoading] = useState(false)
    const [imageImage, setImageImage] = useState<{
        imageUrl: string,
        mode: 'local' | 'cloude'
    }>({
        imageUrl: '',
        mode: 'local'
    })
    const image_input_ref = useRef<HTMLInputElement>(null)
    const { isSEOs } = useCheckUserType()


    function handleChangeInput(e: React.ChangeEvent<HTMLInputElement>) {

        let formdata: ProductCategory;

        switch (e.target.name) {
            case ProductCategoryKeys.M04_ProductCategoryImage:

                if (e.target.files && e.target.files.length > 0) {
                    // setSpinLoading(true)
                    const file = e.target.files[0];
                    const uniqueId = uuidv4();
                    const url = URL.createObjectURL(file)
                    setImageImage({
                        imageUrl: url,
                        mode: 'local'
                    })
                    formdata = {
                        ...formData,
                        M04_ProductCategoryImage: {
                            id: 'santhra',
                            file: file
                        }
                    };


                } else {
                    formdata = {
                        ...formData,
                        M04_ProductCategoryImage: ''
                    }
                }
                break;

            case ProductCategoryKeys.M04_ProductCategoryName:

                formdata = {
                    ...formData,
                    [e.target.name]: e.target.value,
                    M04_ProductCategorySlug: e.target.value,
                }
                break;
            default:
                formdata = {
                    ...formData,
                    [e.target.name]: e.target.value
                }
                break;
        }




        setFormData(formdata)
        performValidationOf(e.target.name, formdata)
        console.log(formdata)

    }

    async function add_catogery() {

        setIsLoading(true)
        // formData.M11_created_by = employee.M15_Employee_id!
        if (performAllValidation(formData) === true) {

            try {

                const formDataReal = new FormData();
                console.log(formData)
                Object.entries(formData).map(
                    data => {

                        console.log(data[0])
                        switch (data[0]) {
                            case ProductCategoryKeys.M04_ProductCategoryImage:
                                const images = data[1] as CustomFile
                                formDataReal.append(`${data[0]}`, images.file)
                                break;
                            case ProductCategoryKeys.M04_ProductCategorySlug:
                                formDataReal.append(data[0], String(data[1]) + new Date().toISOString())
                                break;

                            case ProductCategoryKeys.M04_ProductCategoryMetaTitle:
                            case ProductCategoryKeys.M04_ProductCategoryMetaDescription:
                            case ProductCategoryKeys.M04_ProductCategoryName:
                            case ProductCategoryKeys.M04_ParentCategoryId:
                            case ProductCategoryKeys.M04_is_active:
                                formDataReal.append(data[0], String(data[1]))
                                break;
                        }
                    }

                )



                const res = await api.post<{ success: boolean, data: ProductCategory, errors: any, message: string }>({
                    url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/product_categories`,
                    body: formDataReal,
                    mode: 'admin',
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 0))
                        set_add_progress(percentCompleted)
                    }
                })

                if (res.data.success === true) {
                    updateUi();
                    alertModal.open_alert_modal({
                        content: res.data?.message || 'Category Created',
                        footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
                        title: 'Created'
                    })
                    closeModal()


                } else {
                    alertModal.open_alert_modal({
                        content: res.data?.message || 'something went wrong',
                        footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
                        title: 'Error'
                    })
                    if (res.data.errors) {

                        const errs = res.data.errors;
                        const errData: any = {}

                        for (const key in errs) {
                            errData[key] = errs[key][0]
                        }

                        setErrorData(errData)

                    }
                }
            } catch (error) {
                console.log(error)
            }
            set_add_progress(0)
        }
        setIsLoading(false)

    }
    async function edit_product() {

        setIsLoading(true)
        if (performAllValidation(formData) === true) {

            try {

                const formDataReal = new FormData();
                formDataReal.append('_method', "PUT")

                Object.entries(formData).map(
                    data => {

                        switch (data[0]) {
                            case ProductCategoryKeys.M04_ProductCategoryImage:

                                const images = data[1] as CustomFile

                                if (imageImage.mode === 'local') {
                                    formDataReal.append(`${data[0]}`, images.file)
                                }
                                break;

                            case ProductCategoryKeys.M04_ProductCategorySlug:
                                formDataReal.append(data[0], String(data[1]) + new Date().toISOString())
                                break;
                            case ProductCategoryKeys.M04_ProductCategoryMetaTitle:
                            case ProductCategoryKeys.M04_ProductCategoryMetaDescription:
                            case ProductCategoryKeys.M04_ProductCategoryName:
                            case ProductCategoryKeys.M04_is_active:
                                formDataReal.append(data[0], String(data[1]))
                                break;
                        }
                    }

                )

                const res = await api.post<{ success: boolean, data: ProductCategory, errors: any, message: string }>({
                    url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/product_categories/${id}`,
                    body: formDataReal,
                    mode: 'admin',
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 0))
                        set_add_progress(percentCompleted)
                    }
                })

                if (res.data.success === true) {

                    updateUi();
                    alertModal.open_alert_modal({
                        content: res.data?.message || 'Category Updated',
                        footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
                        title: 'Updated'
                    })
                    closeModal()

                } else {

                    alertModal.open_alert_modal({
                        content: res.data?.message || 'something went wrong',
                        footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
                        title: 'Error'
                    })
                    if (res.data.errors) {

                        const errs = res.data.errors;
                        const errData: any = {}

                        for (const key in errs) {
                            errData[key] = errs[key][0]
                        }

                        setErrorData(errData)

                    }
                }
            } catch (error) {
                console.log(error)
                alertModal.open_alert_modal({
                    content: 'Server Error',
                    footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
                    title: 'Error'
                })
            }
            set_add_progress(0)

        }
        setIsLoading(false)

    }

    const load_Category = async () => {

        const res = await api.get<{ success: boolean, data: ProductCategory, message?: string }>({
            url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/product_categories/${id}`,
            mode: 'admin',

        })
        if (res.data.success === true) {

            setFormData(res.data.data)
            setImageImage({
                imageUrl: res.data.data.M04_ProductCategoryImage as string,
                mode: 'cloude'
            })
        } else {
            throw res.data
        }


    }

    const clear_data = () => {
        setFormData({
            M04_ProductCategoryImage: '',
            M04_ProductCategoryName: '',
            M04_ParentCategoryId: '',
            M04_ProductCategoryMetaTitle: '',
            M04_ProductCategorySlug: '',
            M04_is_active: 1,
            M04_ProductCategoryMetaDescription: ''
        })
        setErrorData({})
        set_add_progress(0)
        setImageImage({
            imageUrl: '',
            mode: 'local'
        })
    }



    useEffect(
        () => {

            const initListSetup = () => {
                clear_data()
                set_loading(true)
                setFormData({
                    M04_ProductCategoryImage: '',
                    M04_ProductCategoryName: '',
                    M04_ParentCategoryId: '',
                    M04_ProductCategoryMetaTitle: '',
                    M04_ProductCategorySlug: '',
                    M04_is_active: 1,
                    M04_ProductCategoryMetaDescription: ''
                })

                Promise.all(
                    []
                ).then(
                    () => {
                        set_loading(false)
                    }
                ).catch(
                    (err) => {
                        set_loading(false)
                    }
                )

            }
            const initEditSetup = () => {
                set_loading(true)
                clear_data()
                Promise.all(
                    [load_Category()]
                ).then(
                    () => {
                        set_loading(false)

                    }
                ).catch(
                    (err) => {
                        set_loading(false)

                    }
                )

            }

            if (mode === 'add' && show === true) {
                setErrorData({})
                initListSetup()

            } else if (mode === 'edit' && show === true) {
                initEditSetup()
            } else {
                set_loading(true)

            }


        }, [show]
    )

    const onclick_add_image_input = () => {
        if (isLoading || loading)
            return;
        image_input_ref.current?.click();
        image_input_ref.current!.value = '';

    }


    const delete_image = () => {
        setImageImage({
            imageUrl: '',
            mode: 'local'
        })
    }


    return (
        <AdminModal show={show} setShow={setShow} >
            {

                <AdminModalContent className=''>


                    <AdminModalHeader progressValue={add_progress}>
                        <AdminModalTitle>Add Product Category</AdminModalTitle>
                    </AdminModalHeader>
                    <AdminModalMiddle>
                        <div>Category Name</div>
                        <Input disabled={isLoading || loading|| isSEOs(employee?.employeeData?.M15_Employee_id!)} value={formData.M04_ProductCategoryName} onChange={handleChangeInput} type="text" name={ProductCategoryKeys.M04_ProductCategoryName} placeholder='Name' />
                        <div className=' text-red-500'>{errorData.M04_ProductCategoryName ? errorData.M04_ProductCategoryName : null}</div>
                        <div className="h-2"></div>
                        <div>Meta tile</div>
                        <Input disabled={isLoading || loading} value={formData.M04_ProductCategoryMetaTitle} onChange={handleChangeInput} type="text" name={ProductCategoryKeys.M04_ProductCategoryMetaTitle} placeholder='meta title' />
                        <div className=' text-red-500'>{errorData.M04_ProductCategoryMetaTitle ? errorData.M04_ProductCategoryMetaTitle : null}</div>
                        <div className="h-2"></div>
                        <div>Meta description</div>
                        <Input disabled={isLoading || loading} value={formData.M04_ProductCategoryMetaDescription} onChange={handleChangeInput} type="text" name={ProductCategoryKeys.M04_ProductCategoryMetaDescription} placeholder='meta description' />
                        <div className=' text-red-500'>{errorData.M04_ProductCategoryMetaDescription ? errorData.M04_ProductCategoryMetaDescription : null}</div>
                        <div className="h-2"></div>
                        <div>Image</div>
                        <div className=' flex gap-1 max-w-full overflow-auto'>
                            {imageImage.imageUrl ?
                                <div className=' relative w-20- h-20 min-w-20 min-h-20 max-w-20 max-h-20   group'>
                                    <img src={`${imageImage.mode === 'cloude' ? `${process.env.REACT_APP_BACKEND_URL}/${imageImage.imageUrl}` : imageImage.imageUrl}`} alt="" className=' h-full w-full' />
                                    <div className=' absolute inset-0 bg-black/50 z-10 opacity-0 group-hover:opacity-100 flex flex-col items-center justify-center '>
                                        <Button disabled={isLoading || loading||isSEOs(employee?.employeeData?.M15_Employee_id!)} onClick={() => delete_image()} >delete</Button>
                                    </div>
                                </div>
                                : <>
                                    <div onClick={onclick_add_image_input} className=' min-h-20 min-w-20 border-2 border-dotted flex items-center justify-center cursor-pointer' ><IconPlus /></div>
                                    <Input disabled={loading || isLoading||isSEOs(employee?.employeeData?.M15_Employee_id!)} ref={image_input_ref} id='imageInput' className=' hidden' onChange={handleChangeInput} type="file" multiple accept='.png, .jpg' name={ProductCategoryKeys.M04_ProductCategoryImage} placeholder='Image' />
                                </>}

                        </div>
                        {/* <Input onChange={handleChangeInput} type="file" name={ProductCategoryKeys.M04_ProductCategoryImage} placeholder='Description' /> */}
                        <div className=' text-red-500'>{errorData.M04_ProductCategoryImage as string ? errorData.M04_ProductCategoryImage as string : null}</div>
                        <div className=' h-2'></div>
                        <div className=' flex gap-1'>
                            <Switch
                                disabled={loading || isLoading||isSEOs(employee?.employeeData?.M15_Employee_id!)}
                                checked={formData.M04_is_active == 1 ? true : false}
                                name={ProductCategoryKeys.M04_is_active}
                                onCheckedChange={
                                    (checked) => handleChangeInput({
                                        target: {
                                            name: ProductCategoryKeys.M04_is_active,
                                            value: checked ? 1 : '0',
                                            checked: checked
                                        }
                                    } as React.ChangeEvent<HTMLInputElement>)
                                }

                            // onChange={handleChangeInput}
                            />
                            <div>is active</div>
                        </div>
                    </AdminModalMiddle>
                    <AdminModalFooter>
                        <div className=' flex justify-end'>
                            {
                                mode === 'add' ?
                                    <Button disabled={isLoading || loading||isSEOs(employee?.employeeData?.M15_Employee_id!)} onClick={add_catogery} >{isLoading ? 'adding...' : 'Add'}</Button>
                                    :
                                    <Button disabled={isLoading || loading} onClick={edit_product}  >{isLoading ? 'editing...' : 'edit'}</Button>}

                        </div>
                    </AdminModalFooter>

                </AdminModalContent>
            }
        </AdminModal>
    )
}
